import {Directive, ViewChild} from "@angular/core";
import {BuyToCoverSettingsComponent} from "../../buy-to-cover-settings/buy-to-cover-settings.component";
import {DropdownFilterComponent} from "@irb-common/components/dropdown-filter/dropdown-filter.component";

@Directive()
export class OptionToCloseRollCell {
    @ViewChild('dropdownFilter') dropdownFilter: any;

    _params: any;
    _selectedValue: OptionToCloseRollOption;
    _options: Array<OptionToCloseRollOption> = new Array();

    componentParent: BuyToCoverSettingsComponent;

    load() {
        this.selectedValue = null;
        this.options = [];
        this.populateSelectedValue();
        this.populateOptions();
    }

    populateSelectedValue() {
        if (this.params.data.optionSelectionMode) {
            switch(this.params.data.optionSelectionMode) {
                case 'ALL_CALLS':
                    this.selectedValue = {name: 'All Calls', value: 'ALL_CALLS'} as OptionToCloseRollOption;
                    break;
                case 'ALL_PUTS':
                    this.selectedValue = {name: 'All Puts', value: 'ALL_PUTS'} as OptionToCloseRollOption;
                    break;
                case 'OPTION_CHAIN':
                    this.selectedValue = {
                        name: this.componentParent.optionFormatter.printOptionSymbol(this.params.data.optionSymbol),
                        value: this.params.data.optionSymbol
                    } as OptionToCloseRollOption;
                    break;
            }
        }
    }

    populateOptions() {
        const existingOSM: Array<string> = this.componentParent.getExistingSymbolOSM(this.params.data.underlyingSymbol);
        const availableOSM: Array<string> = ['ALL_CALLS', 'ALL_PUTS'];

        if (existingOSM !== null && existingOSM !== undefined && existingOSM.length > 0) {
            for (let i = 0; i < availableOSM.length; i++) {
                existingOSM.forEach(osm => {
                    if (osm === availableOSM[i] && osm !== this.params.data.optionSelectionMode) {
                        availableOSM.splice(i, 1);
                    }
                });
            };
        }

        availableOSM.forEach(osm => {
            if (osm === 'ALL_CALLS') {
                this.options.push({name: 'All Calls', value: 'ALL_CALLS'} as OptionToCloseRollOption);
            }
            if (osm === 'ALL_PUTS') {
                this.options.push({name: 'All Puts', value: 'ALL_PUTS'} as OptionToCloseRollOption);
            }
        });
        if (this.params.data.optionSymbol !== null && this.params.data.optionSymbol !== undefined) {
            this.options.push({
                name: this.componentParent.optionFormatter.printOptionSymbol(this.params.data.optionSymbol),
                value: this.params.data.optionSymbol
            } as OptionToCloseRollOption);
        }

        this.options.push({name: 'Select Specific Option...', value: 'VIEW_CHAIN'} as OptionToCloseRollOption);
    }

    populateDropdown(searchStr: any): void {
        this.dropdownFilter.set(DropdownFilterComponent.getFilteredList(searchStr, this.options ));
    }

    set params(params: any) {
        this._params = params;
    }

    get params() {
        return this._params;
    }

    set selectedValue(selectedValue: OptionToCloseRollOption) {
        this._selectedValue = selectedValue;
    }

    get selectedValue() {
        return this._selectedValue;
    }

    set options(options: Array<OptionToCloseRollOption>) {
        this._options = options;
    }

    get options() {
        return this._options;
    }
}

interface OptionToCloseRollOption  {
    name: string;
    value: string;
}
